import {
  Box, Chip, Divider, Paper, Typography,
} from '@material-ui/core'

const Skill = () => (
  <Paper sx={{ p: 2 }}>
    <Typography variant="h5">
      Skill
    </Typography>
    <Divider sx={{ my: 2 }} />
    <Box sx={{ textAlign: 'center' }}>
      <Chip label="React" sx={{ m: 0.5 }} />
      <Chip label="Next.js" sx={{ m: 0.5 }} />
      <Chip label="GraphQL" sx={{ m: 0.5 }} />
      <Chip label="MongoDB" sx={{ m: 0.5 }} />
      <Chip label="Docker" sx={{ m: 0.5 }} />
      <Chip label="MySQL" sx={{ m: 0.5 }} />
      <Chip label="PostgreSQL" sx={{ m: 0.5 }} />
      <Chip label="TensorFlow.js" sx={{ m: 0.5 }} />
      <Chip label="PeerJS" sx={{ m: 0.5 }} />
      <Chip label="React Native" sx={{ m: 0.5 }} />
      <Chip label="AngularJS" sx={{ m: 0.5 }} />
      <Chip label="Wordpress" sx={{ m: 0.5 }} />
    </Box>
  </Paper>
)

export default Skill
